import { api } from "./_client";

// iter-144 — Portfolio management (public list + superadmin CRUD).

export async function listPortfolio() {
    const { data } = await api.get("/portfolio");
    return data.items || [];
}

export async function uploadPortfolioImage({ file, category, caption = "" }) {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("category", category);
    fd.append("caption", caption);
    const { data } = await api.post("/portfolio", fd, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
}

export async function updatePortfolioImage(id, patch) {
    const { data } = await api.patch(`/portfolio/${id}`, patch);
    return data;
}

export async function deletePortfolioImage(id) {
    const { data } = await api.delete(`/portfolio/${id}`);
    return data;
}

export async function reorderPortfolio(ids) {
    const { data } = await api.post("/portfolio/reorder", { ids });
    return data;
}
